import clsx from 'clsx';
import { unwrapResultSuccess } from '@headless-workspace/core-domain';
import { AsyncComponent } from '@headless-workspace/domain/common/server';
import { PropsWithLocale } from '@headless-workspace/glow-ds';
import { PRODUCT_DETAIL_RATING_SECTION_ID, RatingsAndReviewsContent } from '../../../../../src/client';
import { getReviewsWithSortingServerAction } from './getReviewsWithSortingServerAction';

type ProductDetailRatingsAndReviewsSectionProps = PropsWithLocale & {
    rating: number;
    productId: string;
};

const MAX_RATING = 5;

const INIT_REVIEW_WITH_SORTING = {
    reviewCount: 0,
    reviews: [],
    sortingOption: [],
    ratingFilter: [],
};

// Fetch the first 14 reviews for SEO purposes
const BASE_REVIEW_OFFSET = 0;
const BASE_REVIEW_LIMIT = 4;

export const ProductDetailRatingsAndReviewsSection: AsyncComponent<
    ProductDetailRatingsAndReviewsSectionProps
> = async ({ rating, productId, locale }) => {
    const reviewsWithSortingResult = await getReviewsWithSortingServerAction(
        productId,
        BASE_REVIEW_OFFSET,
        BASE_REVIEW_LIMIT,
        [],
    );

    const { reviewCount, reviews, ratingFilter, sortingOption } =
        unwrapResultSuccess(reviewsWithSortingResult) ?? INIT_REVIEW_WITH_SORTING;

    return (
        <section
            id={PRODUCT_DETAIL_RATING_SECTION_ID}
            className={clsx(
                'flex flex-col',
                'py-1.5 px-1 desktop:px-5.5 gap-2.5',
                'scroll-mt-headerFixed tablet:scroll-mt-headerFixedTablet desktopS:scroll-mt-headerFixedMainDesktop desktop:scroll-mt-headerDesktop',
            )}
        >
            <RatingsAndReviewsContent
                ratingFilter={ratingFilter}
                rating={rating}
                baseReviews={reviews}
                reviewCount={reviewCount}
                maxRating={MAX_RATING}
                sortingOption={sortingOption}
                productId={productId}
                locale={locale}
            />
        </section>
    );
};
